export const ja_contacts = {
  main: "Find Us By Below Details",
  location: "169-0051 東京都新宿区西早稲田 1-22-3",
  phone: "080 4905 7900",
  mail: "{address}"
}